module.exports = {"tags":{"default":"view all","tags":["view all","Mindfit","Management ABC","Manage processes","Simulations"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/tagsEN.json
// module id = boxb
// module chunks = 0